<template minapp='mpx' xlang='wxml'>
  <view class="es-search-input__search-container">
    <es-icon color="#000000" class="es-search-input__search-icon" name="search" size="20"/>
    <input type="text" wx:model="{{keywords}}" class="es-search-input__search-input" wx:class="{{borderClass}}"  placeholder="{{placeholder}}" bindinput="onInput" bindfocus="onFocus" bindblur="onBlur"/>
    <view class="clear" bindtap="clear" wx:show="{{keywords}}">
      <es-icon color="#cccccc" name="close-circle-filled" size="20"/>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    classes: [],
    componentName: 'searchInput',
    data: {
      keywords: '',
      isFocus:false
    },
    props: {
      placeholder: {
        type: String,
        value: '',
      },
      showFocusBorder: {
        type: Boolean,
        value: false,
      }
    },
    computed: {
      borderClass(){
        console.log(this.showFocusBorder && this.isFocus?'es-search-input__search-input-focus':'','=======');
        return this.showFocusBorder && this.isFocus?'es-search-input__search-input-focus':''
      }
    },
    methods: {
      clear() {
        this.keywords = '';
        this.$trigger('input', '');
      },
      onInput(e) {
        this.$trigger('input', e.detail.value.trim());
      },
      onFocus(e) {
        this.$trigger('focus');
        this.isFocus = true
      },
      onBlur(e) {
        this.$trigger('blur');
        this.isFocus = false
      }
    },
  })
</script>

<style lang='stylus' scoped>
  +b('search-input')
    +e('search-container')
      display flex
      align-items center
      background #ffffff
      border-radius 8px
      padding 8px 12px 12px

      .clear
        position absolute
        right 26px

    +e('search-icon')
      position absolute
      left 26px

    +e('search-input')
      color #333333
      height 20px
      line-height 20px
      font-size 14px
      background #f4f5f6
      height 44px
      padding 0 44px 0 40px
      border-radius 8px
      outline-color #1473ff
      flex 1
      border 1px solid transparent
      outline none
    +e('search-input-focus')
      border 1px solid #1473ff
    
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
    }
  }
</script>

